import React, { useState } from "react";
import Button from "../widgets/Button";
import routes from "../routes/routes";
import { useNavigate } from "react-router-dom";
import { getUsername } from "../services/CommonService";
import { getExchangeConfig } from "../helper/platformConfig";
import { hasUserAccess } from "../services/CommonService";
import { INVENTORY_GET_ROLE, TRADER_ACCESS_ROLE } from "../constants/roles";
import { Oval } from "react-loader-spinner";


const Sidebar = ({ menu, setMenu }) => {
  const navigate = useNavigate();
  const [omsLoading, setOmsLoading] = useState(false);

  const logout = async () => {
    localStorage.clear();
    const auth0Lock = require("../helper/auth0").auth0Lock;
    auth0Lock.logout({ returnTo: window.location.origin + "/login" });
  };

  const getToken = () => {
    try {
      const tokenResult = localStorage.getItem("okta-token-storage");
      if (tokenResult) {
        const tokenData = JSON.parse(tokenResult);
        return tokenData?.accessToken || "";
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
    }
    return "";
  };

  const handleOmsClick = () => {
    if (omsLoading) {
      return;
    }

    setMenu(false);
    const token = getToken();
    if (!token) {
      console.error("No token available");
      return;
    }

    setOmsLoading(true);
    const omsBaseUrl = window.env.OMS_PORTAL_LOGIN_BASE_URL;
    const omsUrl = `${omsBaseUrl}/api/order/portalLogin`;

    // Open a new tab immediately
    const newWindow = window.open("", "_blank");
    
    if (!newWindow) {
      console.error("Failed to open new window. Please allow popups.");
      setOmsLoading(false);
      return;
    }

    // Create a form in the new window and submit it
    // HTML form submission naturally handles cookies and redirects properly
    const escapedToken = token.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    const formHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Redirecting to OMS...</title>
        </head>
        <body>
          <p>Redirecting to OMS...</p>
          <form id="omsForm" method="POST" action="${omsUrl}">
            <input type="hidden" name="accessToken" value="${escapedToken}" />
          </form>
          <script>
            // Auto-submit the form - browser will handle redirect and cookies
            document.getElementById('omsForm').submit();
          </script>
        </body>
      </html>
    `;

    newWindow.document.write(formHtml);
    newWindow.document.close();

    // Reset loading state after a short delay to allow form submission
    setTimeout(() => {
      setOmsLoading(false);
    }, 1000);
  };

  const menuList = [
    {
      href: routes.listing,
      title: getExchangeConfig().sidebarLabels[0],
    },
    {
      href: routes.documents,
      title: getExchangeConfig().sidebarLabels[1],
    },
    {
      href: routes.holding,
      title: getExchangeConfig().sidebarLabels[2],
    },
  ];

  if (hasUserAccess([INVENTORY_GET_ROLE])) {
    menuList.push({
      href: routes.inventory,
      title: getExchangeConfig().sidebarLabels[3],
    });
    menuList.push({
      href: routes.retirementRequests,
      title: getExchangeConfig().sidebarLabels[4],
    });
    menuList.push({
      href: routes.retirementHistory,
      title: getExchangeConfig().sidebarLabels[5],
    });
  }

  let showOmsButton = false;
  if (hasUserAccess([TRADER_ACCESS_ROLE])) {
    showOmsButton = true;
  }

  return (
    <aside
      className={`${
        menu ? "max-lg:left-0" : "max-lg:-left-full"
      } max-lg:absolute relative px-4 py-5 2xl:py-8 flex flex-col justify-between h-full w-64 2xl:w-72 bg-foreground transition-all z-50`}
    >
      <div className="flex flex-col gap-3 2xl:gap-4">
        {menuList.map((items, i) => (
          <Button
            key={i}
            title={items.title}
            onClick={() => {
              setMenu(false);
              navigate(items.href);
            }}
            size="lg"
          />
        ))}
        {showOmsButton && (
          <Button
            title={omsLoading ? "Loading..." : "OMS"}
            onClick={handleOmsClick}
            size="lg"
            isDisabled={!getToken() || omsLoading}
            icon={
              omsLoading ? (
                <Oval
                  height={16}
                  width={16}
                  color="#ffffff"
                  wrapperStyle={{ display: "inline-block" }}
                  visible={true}
                  ariaLabel="loading"
                />
              ) : null
            }
          />
        )}
      </div>

      <div className="flex flex-col gap-3">
        <Button title="Logout" size="lg" onClick={logout} />
        <div>
          <p className="text-sm text-black text-center w-full line-clamp-2">
            Logged in as <span className="capitalize">{getUsername()}</span>
          </p>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;